import React from 'react';

const Footer = () => {
    return (
        <div className="footer">
            <p style={{margin:"4px"}}>Craig Robertson</p>
        </div>
    ) 
}

export default Footer;